module.exports = __webpack_public_path__ + "static/media/leftbn.bfbf98ee.png";